import { jsonp } from '@ifeng-fe/ui_base';
import axios from 'axios';

export const getMedalList = async () => {
  return await jsonp('https://shankapi.ifeng.com/feedflow/coopdoc/doc_6e1b0b46ecbe2f5f7b305e2467b2068b/info/cb?callback=cb', {
    jsonpCallback: 'cb',
    cache: false,
  });
};

export const getTime = () => {
  const currentTime = new Date('2021-01-14 09:12:10');
  const y = currentTime.getFullYear();// 年
  let m = currentTime.getMonth() + 1;// 月

  m = m < 10 ? `0${m}` : m;
  let d = currentTime.getDate();// 日

  d = d < 10 ? `0${d}` : d;
  let h = currentTime.getHours();// 时

  h = h < 10 ? `0${h}` : h;
  let minute = currentTime.getMinutes();// 分

  minute = minute < 10 ? (`0${ minute}`) : minute;
  const Seconds = currentTime.getSeconds();// 秒

  return `${y }-${ m }-${ d } ${ h }:${ minute }:${ Seconds}`;
};

// 首次请求action为defalult,后面都为up
export const getContentList = async ({
  pageNo
}) => {
  // return axios({
  //   method: 'get',
  //   url: `https://staging.nine.ifeng.com/recomlist?id=WO22&ch=winoly&action=${pageNo === 1 ? 'default' : 'up'}&pullNum=${pageNo}&ts=${encodeURIComponent(getTime())}&${window.location.search.slice(1)}&nosign=1`,
  // }).then(response => {
  //   return response;
  // });
  const nineDomain = typeof window === 'object' && window.allData?.__nd__ ? window.allData.__nd__ : 'ne883dbn.ifeng.com';
  
  return await jsonp(`https://${ nineDomain }/recomlist?id=WO22&ch=winoly&action=${pageNo === 1 ? 'default' : 'up'}&pullNum=${pageNo}&ts=${encodeURIComponent(getTime())}&${window.location.search.slice(1)}&nosign=1&callback=cb`, {
    jsonpCallback: 'cb2',
    cache: false,
  });
};

const linkBasePath = 'https://shankapi.ifeng.com/linkall';

export const getAnalyzeLink = async (link) => {
  const res = await axios(`${linkBasePath}/outLink/handleOutLink?link=${encodeURIComponent(link)}`);

  return res;
};
